export default "__VITE_ASSET__DlbZ7B_H__"